import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Layout, Modal, Button } from "antd";

import SidebarContent from "./SidebarContent";
import {
  toggleCollapsedSideNav,
  updateWindowWidth,
} from "appRedux/actions/Setting";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import UnlockOutlined from "@ant-design/icons/lib/icons/UnlockOutlined";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Moment from "moment";

dayjs.extend(utc);

const { Sider } = Layout;

const Sidebar = () => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);

  const { themeType, navStyle } = useSelector(({ settings }) => settings);
  const { navCollapsed, width } = useSelector(({ common }) => common);
  const ap_e_raw = Cookies.get("ap_e");
  const ap_e = ap_e_raw ? JSON.parse(ap_e_raw) : [];
  const expiredDate = ap_e[0].expired_password;
  const today = dayjs().format("YYYY-MM-DD");
  const formatExpiredDate = Moment(expiredDate).format("YYYY-MM-DD");

  const history = useHistory();

  const onToggleCollapsedNav = () => {
    dispatch(toggleCollapsedSideNav(!navCollapsed));
  };

  const showModal = useCallback(() => {
    if (localStorage.getItem("USER_ID") === ap_e[0].user_id) {
      if (today === formatExpiredDate) {
        setOpenModal(true);
      }
    }
  }, [ap_e, today, formatExpiredDate]);

  const closeModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      dispatch(updateWindowWidth(window.innerWidth));
    });
  }, [dispatch]);

  useEffect(() => {
    showModal();
  }, [showModal]);

  let drawerStyle = "gx-collapsed-sidebar";

  if (navStyle === NAV_STYLE_FIXED) {
    drawerStyle = "";
  } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar gx-mini-custom-sidebar";
  } else if (navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
    drawerStyle = "gx-custom-sidebar";
  } else if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
    drawerStyle = "gx-mini-sidebar";
  } else if (navStyle === NAV_STYLE_DRAWER) {
    drawerStyle = "gx-collapsed-sidebar";
  }
  if (
    (navStyle === NAV_STYLE_FIXED ||
      navStyle === NAV_STYLE_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) &&
    width < TAB_SIZE
  ) {
    drawerStyle = "gx-collapsed-sidebar";
  }

  const modalConfirmChangePassword = (
    <Modal
      visible={openModal}
      footer={null}
      style={{ overflow: "visible" }}
      onCancel={() => {
        closeModal();
      }}
      centered
      maskClosable={false}
      className="confirm-modal"
      title={""}
      destroyOnClose
      closable={false}
      width={"21.188rem"}
    >
      <div className="modal-expired">
        <div className="expired-icon">
          <UnlockOutlined />
        </div>
        <div className="expired-title">
          <span>Informasi</span>
        </div>

        <div className="expired-container">
          <div className="expired-detail">
            "Demi keamanan akun, Anda diharuskan mengganti kata sandi"
          </div>
        </div>

        <div className="expired-container-button">
          <div className="expired-button">
            <Button
              type="primary"
              className="modal-confirm-accept-button"
              onClick={() => history.push("/expired-password")}
            >
              Ya, Lanjutkan
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );

  return (
    <>
      {modalConfirmChangePassword}
      <Sider
        className={`gx-app-sidebar ${drawerStyle} ${
          themeType !== THEME_TYPE_LITE ? "gx-layout-sider-dark" : null
        }`}
        trigger={null}
        collapsed={
          width < TAB_SIZE
            ? false
            : navStyle === NAV_STYLE_MINI_SIDEBAR ||
              navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
        }
        theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
        collapsible
      >
        {navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE ? (
          <Drawer
            className={`gx-drawer-sidebar ${
              themeType !== THEME_TYPE_LITE ? "gx-drawer-sidebar-dark" : null
            }`}
            placement="left"
            closable={false}
            onClose={onToggleCollapsedNav}
            visible={navCollapsed}
          >
            <SidebarContent />
          </Drawer>
        ) : (
          <SidebarContent />
        )}
      </Sider>
    </>
  );
};
export default Sidebar;
